import React from 'react';
import PropTypes from 'prop-types';
import { ClientContextProvider } from 'react-fetching-library';

import { client } from '../../api/client';
import { ThemeContextProvider } from '../Theme';

const WrapPageElement = ({ children }) => (
  <ClientContextProvider client={client}>
    <ThemeContextProvider>{children}</ThemeContextProvider>
  </ClientContextProvider>
);

WrapPageElement.propTypes = {
  children: PropTypes.node,
};

export default WrapPageElement;
